import { useMatches } from "react-router-dom";

export const useIsStandardUUID = (): boolean => {
  const matches = useMatches();

  return matches.some((match) => {
    // Check if the route has session or token parameters (which are UUIDs)
    return !!(match.params.session || match.params.token);
  });
};
